import { NgModule, InjectionToken } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

import { LanguagesListPage } from './pages/languages/languages-list.page';
import { LanguagesEditPage } from './pages/languages/languages-edit.page';
import { LanguagesListComponent } from './components/languages-list/languages-list.component';
import { LanguagesFormComponent } from './components/languages-form/languages-form.component';

import { IdentificationTypesListPage } from './pages/identification-types/identification-types-list.page';
import { IdentificationTypesEditPage } from './pages/identification-types/identification-types-edit.page';

import { IdentificationTypesListComponent } from './components/identification-types-list/identification-types-list.component';
import { IdentificationTypesFormComponent } from './components/identification-types-form/identification-types-form.component';

@NgModule({
    imports: [
        ConfirmDialogModule,
        SharedModule,
        TranslatePipe,
        TranslateDirective
    ],
    declarations: [
        LanguagesListPage,
        LanguagesEditPage,
        LanguagesListComponent,
        LanguagesFormComponent,

        IdentificationTypesEditPage,
        IdentificationTypesListPage,
        IdentificationTypesListComponent,
        IdentificationTypesFormComponent,
    ],
    exports: [
        LanguagesListPage,
        LanguagesEditPage,

        IdentificationTypesListPage,
        IdentificationTypesEditPage

    ],
    providers: [
        ConfirmationService,
    ]
})
export class CommonModule {
    constructor() { }
}